import React from 'react';
import { StatisticCard } from '../StatisticCard/StatisticCard';
import {
  useClientFuelHistoryEvents,
  useClientHistoryTotalFuelLiters,
  useClientHistoryTotalPriceFuels
} from 'entities/navigation';
import { useIntl } from 'react-intl';

import { useStyles } from './styles';

export const RefuelingCard = () => {
  const classes = useStyles();
  const clientFuelEventsHistory = useClientFuelHistoryEvents();
  const clientHistoryTotalFuelLiters = useClientHistoryTotalFuelLiters();
  const clientHistoryTotalPriceFuels = useClientHistoryTotalPriceFuels();
  const { formatMessage } = useIntl();

  const countRefuels = clientFuelEventsHistory.length;

  return (
    <StatisticCard
      iconKind="localGasStationOutlined"
      primaryText={`${countRefuels} - ${Math.round(clientHistoryTotalFuelLiters)} L <span class=${classes.text}>(${Math.round(clientHistoryTotalPriceFuels)} EUR)</span>`}
      secondaryText={formatMessage({ id: 'refueling' })}
    />
  );
};
